export const URL_Clinic = (`${process.env.REACT_APP_HOST}/clinic`)
export const URL_Doctor = (`${process.env.REACT_APP_HOST}/doctor`)
export const URL_PreScheduling = (`${process.env.REACT_APP_HOST}/prescheduling`)
export const URL = process.env.REACT_APP_HOST
export const URL_FunctionalitySchedule = (`${process.env.REACT_APP_HOST}/functionalityschedule`)